export enum FullscreenButtonMode {
  DISABLED = 'disabled',
  ENABLED = 'enabled',
  ENABLED_AUTO_ENTER = 'enabled_auto_enter'
}